module.exports = __webpack_public_path__ + "static/media/bgcourse-1.422d0089.jpg";